import React, {memo} from "react";
import {Button, Col, Row} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {
    actionChangeListQuestions,
    handelArrowModalShoppingCard,
    handelChangeLevelPaymentModalShoppingCard,
    handelToggleAnimationModalShoppingCard,
    actionChangeInputsModalShoppingCard,
    actionChangeSelectableQuestion
} from "../../../../../../redux/actions/modals/modalShoppingCard";
import swal from 'sweetalert';
import axios from "axios";
import {BASE_URL, QUESTIONS_POST} from "../../../../../../apis";
import qs from "querystring";
import {useRouteMatch} from "react-router-dom";
import {
    actionChangeHandelModalAddPGratuity,
    actionChangeInputsModalAddGratuity
} from "../../../../../../redux/actions/modals/modalGratuity/modalGratuity";

const PostScheduleFooter = () => {
    const dispatch = useDispatch();
    const match = useRouteMatch();
    const {statusAnimation} = useSelector(state => state.modalShoppingCard);
    const {activeSelectTablePostSchedule} = useSelector(state => state.modalShoppingCard);
    const store = useSelector(state => state.stores.list_stores.find(storeItem => storeItem.id === match.params.store));
    const {token} = useSelector(state => state.user);

    const handelToggleAnim = () => {
        dispatch(handelToggleAnimationModalShoppingCard(!statusAnimation));
    };

    const handelNextLevelShoppingCard = () => {
        if (Object.keys(activeSelectTablePostSchedule).length === 0)
            swal({
                title: "زمان ارسال",
                text: 'لطفا یک بازه زمانی برای ارسال کالا مشخص کنید.',
                buttons: {
                    cancel: "تایید",
                },
                icon: "error",
            });
        else{
            handleGetQuestionsApi();
        }
    };

    const handleGetQuestionsApi = () => {
        let data = {store:store.id};
        if(localStorage.getItem("editOrderMode") !== undefined && localStorage.getItem("editOrderMode") !== null) // az safheye virayeshe sefaresh oomadim
            data = {...data, order: localStorage.getItem("editOrderMode")};

        axios({
            method: 'post',
            url:BASE_URL+QUESTIONS_POST,
            data: qs.stringify(data),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then(response => {
            if (response.data.status === 'ok') {
                if (response.data.questions && response.data.questions.length > 0) {
                    dispatch(actionChangeListQuestions(response.data.questions));
                }
                dispatch(handelArrowModalShoppingCard('next'));
                setTimeout(() => {
                        dispatch(handelChangeLevelPaymentModalShoppingCard('QUESTIONS', ''));
                    }
                    , 400);
                setTimeout(() => {
                    handelToggleAnim();
                }, 100);

                if(response.data.description) // age az virayeshe sefaresh oomade bashim, meghdare pishfarze description jaygozin beshe
                    setTimeout(() => {
                        dispatch(actionChangeInputsModalShoppingCard("orderDescription", response.data.description));
                    }, 100);
                if(response.data.gratuity) // age az virayeshe sefaresh oomade bashim, meghdare pishfarze description jaygozin beshe
                    setTimeout(() => {
                        handelSelectableQuestion(response.data.gratuity.question, response.data.gratuity.answerId, response.data.gratuity.answerTitle);
                    }, 100);
                else
                    dispatch(actionChangeInputsModalAddGratuity('price', ''));
            }
        });
    };


    /* age az virayeshe sefaresh, gozineye virayeshe liste mahsoolat oomade bashim, solaat be soorate pishfarz entekhab shode bashan */
    const {price: gratuity} = useSelector(state => state.modalGratuity);
    const handelSelectableQuestion = (question, answerId, answerTitle) => {
        let ItemNewSelectableQuestion = {question, answerId, answerTitle};
        if (question === 'reward' && answerId !== 4) {
            if (gratuity !== '')
            dispatch(actionChangeInputsModalAddGratuity('price', ''));
        }
        if (answerTitle === 'مبلغ دلخواه') {
            dispatch(actionChangeHandelModalAddPGratuity(true));
        } else if(question ==='reward' && answerTitle === 'صفر') {
            dispatch(actionChangeSelectableQuestion({...ItemNewSelectableQuestion,answerTitle:0}));
        }else {
            dispatch(actionChangeInputsModalAddGratuity('price', answerTitle));
            dispatch(actionChangeSelectableQuestion(ItemNewSelectableQuestion));
        }
    };


    const handelPrevLevelShoppingCard = () => {
        dispatch(handelArrowModalShoppingCard('prev'));
        setTimeout(() => {
            dispatch(handelChangeLevelPaymentModalShoppingCard('LIST_PRODUCTS', 'سبد خرید'));
        }, 400);
        setTimeout(() => {
            handelToggleAnim();
        }, 100);
    };
    return (
        <Row className={'w-100 m-auto'}>
            <Col xs={12}>
                <div className={'description-footer-time-selected'}>
                    <h6>توجه !</h6>
                    <p>سفارش ها بین بازه انتخاب شده به دست شما خواهد رسید. جهت تنظیم بهینه ارسال ها تعیین زمان خاصی از
                        بازه انتخاب شده امکان پذیر نمیباشد.</p>
                </div>
            </Col>
            <Col xs={6} className={'mt-1'}>
                <Button variant="success" className={'base-btn-green'} block onClick={handelNextLevelShoppingCard}>
                    <span>مرحله بعدی</span>
                </Button>
            </Col>
            <Col xs={6} className={'mt-1'}>
                <Button variant="success" className={'base-btn-green-border'} block onClick={handelPrevLevelShoppingCard}>
                    <span>مرحله قبلی</span>
                </Button>
            </Col>

        </Row>
    );
};

export default memo(PostScheduleFooter);
